import { Stack, Typography } from '@mui/material';
import PscRisk from '../../constants/psc-risk.constant';
import { useAppSelector } from '../../hooks';

interface PscVesselRiskProps {
    imoNumber: string;
}

const PscVesselRisk = ({ imoNumber }: PscVesselRiskProps) => {
    const mouData = useAppSelector((state) => state.MOURisk.List[imoNumber]);
    const vesselRisk = useAppSelector((state) => state.MOURisk.Selected[imoNumber]);

    const renderRisk = (): JSX.Element => {
        if (vesselRisk && vesselRisk.RiskId !== 0) {
            return (
                <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'}>
                    <Typography style={{ color: PscRisk[vesselRisk.RiskId].color, fontWeight: 'bold' }}> {PscRisk[vesselRisk.RiskId].text}</Typography>
                </Stack>
            );
        } else if (vesselRisk && vesselRisk.RiskId === 0) {
            return <strong>Not Yet Visited</strong>;
        }

        return <></>;
    };

    return <>{mouData?.MOURisk?.length === 0 && !vesselRisk ? <></> : <>{renderRisk()}</>}</>;
};

export default PscVesselRisk;
